import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { apiClient } from '../../utils/api';

interface UseSignOutReturn {
  signOut: () => Promise<void>;
}

export const useSignOut = (): UseSignOutReturn => {
  const navigate = useNavigate();
  const { signOut: storeSignOut, refreshToken } = useAuthStore();

  const signOut = useCallback(async () => {
    try {
      await apiClient.get('/api/v1/auth/logout', {
        headers: {
          Authorization: refreshToken
        }
      });
    } catch (error) {
      console.error('로그아웃 중 오류 발생:', error);
    } finally {
      storeSignOut();
      navigate('/auth/signin');
    }
  }, [storeSignOut, navigate, refreshToken]);

  return { signOut };
}; 